export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-base text-background-50"></i>
              </span>
              <span className="text-base font-bold font-heading text-background-50 whitespace-nowrap">
                被窝影院
              </span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed mb-4">
              被窝影院汇聚免费电视剧大全，提供最新电视剧免费在线观看。
              热播剧完整版高清流畅不缓冲，国产剧免费观看的首选追剧平台。
              窝在被窝里看好剧，是我们能想到的最幸福的事。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-wechat-line text-sm text-background-300"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-weibo-line text-sm text-background-300"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-bilibili-line text-sm text-background-300"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline whitespace-nowrap">热播榜单</a>
              <a href="#carousel" onClick={(e) => handleScroll(e, '#carousel')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline whitespace-nowrap">热门专题</a>
              <a href="#updates" onClick={(e) => handleScroll(e, '#updates')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline whitespace-nowrap">最新动态</a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs text-background-400 cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">古装大剧</span>
              <span className="text-xs text-background-400 cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">悬疑刑侦</span>
              <span className="text-xs text-background-400 cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">都市情感</span>
              <span className="text-xs text-background-400 cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">科幻巨制</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs text-background-500 whitespace-nowrap">更多合作伙伴即将入驻</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 被窝影院 · 免费电视剧大全 · 全集在线看 · 最新电视剧免费 · 热播剧完整版 · 国产剧免费观看
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">服务条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}